import { RequiredUpload } from '@flatsy/types/Applications'
import { Files, FilesKind, FilesMainKind, FilesStatus } from '@flatsy/types/Files'
import { isFileError } from '../IsFileError'
import { FilesKindsList, FormatedUppyFiles, RequiredUploadToFlatArrayType, UppyFile } from './Type'

/**
 * @description build a flat array of kind and main kind to render inside a list
 * @param requiredUpload back-end list of required upload for an applicant
 */
export const requiredUploadToFlatArray = (
  requiredUpload?: RequiredUpload[]
): RequiredUploadToFlatArrayType => {
  const mainKinds: FilesMainKind[] = []
  const filesKinds: FilesKindsList[] = []

  if (requiredUpload) {
    requiredUpload.forEach((upload) => {
      mainKinds.push(upload.kind)
      if (upload.required) {
        upload.required.forEach((file) => {
          if (upload.kind === 'proof_of_id') {
            filesKinds.push({
              kind: file.kind,
              main: upload.kind,
              min: file.min,
              idGroup: 1,
            })
          } else {
            filesKinds.push({
              kind: file.kind,
              main: upload.kind,
              min: file.min,
            })
          }
        })
      }
    })
  }

  return {
    mainKinds,
    filesKinds,
  }
}

export interface restrictedWithUploadedFilesType {
  mainKinds: FilesMainKind[]
  filesKinds: FilesKind[]
}

/**
 * @description build a flat array of kind and mainKind and check if a kind is not already uploaded
 * @param array user requiredUploadToFlatArray function to build a formated array
 * @param files Already upload files
 * @param uppy.UppyFiles Files upload in uppy state
 * @param uppy.currentFile Current file object
 */
export const restrictedWithUploadedFiles = (
  array: RequiredUploadToFlatArrayType,
  files: Files[],
  uppy: {
    UppyFiles: FormatedUppyFiles | undefined
    currentFile: UppyFile
  }
): restrictedWithUploadedFilesType => {
  const { mainKinds } = array
  const filesKinds: FilesKind[] = []
  let filesKindsList: FilesKindsList[] = []

  files.forEach((file) => {
    if (file.main_kind === FilesMainKind.PROOF_OF_ID && file.status === FilesStatus.VALIDATED) {
      filesKindsList = array.filesKinds.filter((fileKind) => !fileKind.idGroup)
    }
  })
  if (filesKindsList.length === 0) {
    filesKindsList = array.filesKinds
  }

  filesKindsList.forEach((doc) => {
    const hasMainKind = files.filter((file) => file.main_kind === doc.main && !isFileError(file))
    if (hasMainKind.length) {
      const hasNoImportedFileForKind = hasMainKind[0].kind !== doc.kind
      const hasMinimumRequired = hasMainKind.length >= doc.min
      if (hasNoImportedFileForKind || !hasMinimumRequired) {
        filesKinds.push(doc.kind)
      }
    } else {
      let canPush = true
      if (uppy && uppy.UppyFiles) {
        const { UppyFiles } = uppy
        const keys = Object.keys(uppy.UppyFiles)
        const hasKindInUppy = keys.filter(
          (el) => el !== uppy.currentFile.id && UppyFiles[el].kind === doc.kind
        )
        if (hasKindInUppy.length && hasKindInUppy.length >= doc.min) {
          canPush = false
        }
      }
      if (canPush) {
        filesKinds.push(doc.kind)
      }
    }
  })

  return {
    mainKinds,
    filesKinds,
  }
}
